import React, { useEffect, useState, useCallback, useRef } from "react"
import MetaTags from "react-meta-tags"
import {
    Col,
    Container,
    Row,
    Card,
    CardBody
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import Mdatatable from "components/Datatables/Mdatatables"
import { get } from "helpers/api_helper"
import { customFormatDate } from 'helpers/basic_helper'
import { GETORDERFORMS_URL } from 'helpers/url_helper'
import "react-datepicker/dist/react-datepicker.css"
import { useDispatch, useSelector } from "react-redux"
import Datatables from "components/Datatables/datatable";
import ClientDropdown from "utils/client_dropdown";
import "flatpickr/dist/themes/material_red.css"
import Flatpickr from "react-flatpickr"
import Timezone from "utils/timezone";
import Select from 'react-select';
import moment from "moment";
import LoaderCard from "modules/loader"

const sort_date_filters = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 7 days", value: "last_7_days" },
    { label: "Last 15 days", value: "last_15_days" },
    { label: "This month", value: "this_month" },
    { label: "Last month", value: "last_month" },
    { label: "Last 45 days", value: "last_45_days" },
    { label: "Last 60 days", value: "last_60_days" }
];


const isType = 'orderform'
const Orderform = ({ isCall = false }) => {
    // const dispath = useDispatch()
    // const { loading } =  useSelector(state => state.Challans);
    const [orderformsLoad, setOrderformsLoad] = useState(false);
    const [batchProgress, setBatchProgress] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [challans, setChallans] = useState({ total_size: 0, rows: [] });
    const [selectedRangeValue, setSelectedRangeValue] = useState(null);
    const [filters, setFilters] = useState({
        'search': null,
        'client': null,
        '_startdate': null,
        '_enddate': null,
    });
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    });

    const batchCancelRef = useRef(false);
    const isBatchRunningRef = useRef(false);
    const totalSizeRef = useRef(0);
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            batchCancelRef.current = true;
            isBatchRunningRef.current = false;
        };
    }, []);

    useEffect(() => {
        totalSizeRef.current = challans?.total_size || 0;
    }, [challans?.total_size]);

    const handleCancelBatch = () => {
        batchCancelRef.current = true;
        isBatchRunningRef.current = false;
        if (isMountedRef.current) {
            setBatchProgress(prev => prev ? ({ ...prev, active: false, stopped: true }) : null);
            setOrderformsLoad(false);
        }
    };

    const handlePaginationChange = useCallback((newPag) => {
        setPagination(prev => {
            if (
                prev.page === newPag.page &&
                prev.limit === newPag.limit &&
                prev.search === newPag.search &&
                Boolean(prev.isAll) === Boolean(newPag.isAll)
            ) {
                return prev;
            }
            return { ...prev, ...newPag };
        });
    }, []);

    const getData = useCallback(async () => {
        const isAllSelected = pagination?.isAll || pagination?.limit === 'all' || pagination?.limit === 'All' || (typeof pagination?.limit === 'number' && pagination?.limit > 100);

        const cleanFilters = Object.fromEntries(
            Object.entries(filters)
                .filter(([key, value]) => value !== null && value !== undefined && value !== '' && key !== 'bydate')
                .map(([key, value]) => [
                    key,
                    value?.hasOwnProperty('value') ? value.value : value
                ])
        );

        if (isAllSelected) {
            batchCancelRef.current = true;
            await new Promise(r => setTimeout(r, 60));
            batchCancelRef.current = false;
            isBatchRunningRef.current = true;

            const batchSize = 250;
            const currentTotal = totalSizeRef.current || 0;
            setBatchProgress({
                active: true,
                loaded: 0,
                total: currentTotal,
                percent: 0
            });
            setOrderformsLoad(true);

            try {
                let currentPage = 1;
                let accumulatedRows = [];
                let totalCount = currentTotal;
                let hasMore = true;

                while (hasMore && !batchCancelRef.current) {
                    const queryParams = new URLSearchParams({
                        ...cleanFilters,
                        page: currentPage,
                        sizePerPage: batchSize,
                        limit: batchSize,
                        search: pagination?.search || ''
                    }).toString();

                    const res = await get(`${GETORDERFORMS_URL}?${queryParams}`);
                    if (batchCancelRef.current) break;

                    if (res && res.status === 200 && res.response) {
                        const responseData = res.response;
                        const newRows = responseData?.rows || (Array.isArray(responseData) ? responseData : []);
                        if (responseData?.total_size !== undefined) {
                            totalCount = responseData.total_size;
                        } else if (totalCount === 0) {
                            totalCount = newRows.length;
                        }

                        const existingIds = new Set(accumulatedRows.map(r => r.id));
                        const uniqueNew = newRows.filter(r => !existingIds.has(r.id));
                        accumulatedRows = [...accumulatedRows, ...uniqueNew];

                        if (!isMountedRef.current) break;

                        setChallans({
                            total_size: totalCount,
                            rows: [...accumulatedRows]
                        });

                        const percent = totalCount > 0 ? Math.min(100, Math.round((accumulatedRows.length / totalCount) * 100)) : 100;
                        setBatchProgress({
                            active: true,
                            loaded: accumulatedRows.length,
                            total: totalCount,
                            percent
                        });

                        if (newRows.length < batchSize || accumulatedRows.length >= totalCount || newRows.length === 0) {
                            hasMore = false;
                        } else {
                            currentPage++;
                        }
                    } else {
                        hasMore = false;
                    }
                }

                if (!batchCancelRef.current && isMountedRef.current) {
                    setBatchProgress(prev => ({
                        ...prev,
                        active: false,
                        completed: true,
                        loaded: accumulatedRows.length,
                        total: totalCount,
                        percent: 100
                    }));
                }
            } catch (err) {
                console.error("Batch load error:", err);
                if (isMountedRef.current) {
                    setBatchProgress(prev => prev ? ({ ...prev, active: false }) : null);
                }
            } finally {
                isBatchRunningRef.current = false;
                if (isMountedRef.current) {
                    setOrderformsLoad(false);
                }
            }
            return;
        }

        // Normal single page request
        batchCancelRef.current = true;
        isBatchRunningRef.current = false;
        if (isMountedRef.current) {
            setBatchProgress(null);
            setOrderformsLoad(true);
        }

        try {
            const queryParams = new URLSearchParams({
                ...cleanFilters,
                page: pagination?.page || 1,
                sizePerPage: pagination?.limit || 10,
                limit: pagination?.limit || 10,
                search: pagination?.search || ''
            }).toString();

            const res = await get(`${GETORDERFORMS_URL}?${queryParams}`);
            if (!isMountedRef.current) return;
            if (res && res.status === 200 && res.response) {
                setChallans(res.response);
            } else {
                setChallans({ total_size: 0, rows: [] });
            }
        } catch (err) {
            console.error("Failed to load orderforms:", err);
            if (isMountedRef.current) {
                setChallans({ total_size: 0, rows: [] });
            }
        } finally {
            if (isMountedRef.current) {
                setOrderformsLoad(false);
            }
        }
    }, [filters, pagination]);

    useEffect(() => {
        getData();
        return () => {
            batchCancelRef.current = true;
            isBatchRunningRef.current = false;
        };
    }, [getData]);

    const handleFilterChange = (value) => {
        let startDate = moment().endOf('day');
        let endDate = moment().endOf('day');

        switch (value) {
            case 'today':
                startDate = moment().startOf('day');
                break;
            case 'yesterday':
                startDate = moment().subtract(1, 'days').startOf('day');
                endDate = moment().subtract(1, 'days').endOf('day');
                break;
            case 'last_7_days':
                startDate = moment().subtract(7, 'days').startOf('day');
                break;
            case 'last_15_days':
                startDate = moment().subtract(15, 'days').startOf('day');
                break;
            case 'this_month':
                startDate = moment().startOf('month');
                break;
            case 'last_month':
                startDate = moment().subtract(1, 'months').startOf('month');
                endDate = moment().subtract(1, 'months').endOf('month');
                break;
            case 'last_45_days':
                startDate = moment().subtract(45, 'days').startOf('day');
                break;
            case 'last_60_days':
                startDate = moment().subtract(60, 'days').startOf('day');
                break;
        }

        setFilters(prev => ({
            ...prev,
            _startdate: startDate.format('YYYY-MM-DD'),
            _enddate: endDate.format('YYYY-MM-DD'),
            bydate: [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')]
        }));
    }

    const printPdf = (orderform) => {
        const CN = orderform.orderform_number;
        window.open(`/orderform/print?_orderform=${CN}`, '_blank');
    };

    /**
     * DataTable with Condition based row formating
     */
    let datatableData = [
        {
            dataField: 'id',
            text: 'Id'
        }, {
            dataField: 'orderform_number',
            text: 'OrderForm #',
            formatter: (cell, row) => <a title="Click to View Orderform" href={`/orderform/print?_orderform=${row.orderform_number}`} target="_blank" rel="noreferrer">
                # {row.orderform_number} <br />   <span className={`ms-2 badge badge-soft-warning font-size-12`}>{customFormatDate(row?.orderform_date, 'DD MMM, YY')}</span>
            </a>,
        }, {
            dataField: 'order_id',
            formatter: (cell, row) => <span className={`text-success font-size-14`}>{row.order_id}</span>,
            text: 'Order #'
        }, {
            dataField: 'clientname',
            text: 'Client #'
        }, {
            dataField: 'order_date',
            text: 'Order Date',
            formatter: (cell, row) => customFormatDate(row?.order_date, 'DD MMM, YY')
        }, {
            dataField: 'due_date',
            text: 'Due Date',
            formatter: (cell, row) => customFormatDate(row?.due_date, 'DD MMM, YY')
        }
    ];

    if (isCall) {
        return <Card>
            <CardBody>
                <Datatables
                    isSearch={true}
                    columns={datatableData}
                    showTableOnly={true}
                    rowsLength={challans?.total_size || 0}
                    rows={challans?.rows || []}
                    keyField={'id'}
                    handleAddButton={() => {
                        setEditableObj(null)
                        isOpen(true)
                    }}
                    title="All Orderforms"
                    loading={orderformsLoad && (!batchProgress || batchProgress.loaded === 0)}
                    batchProgress={batchProgress}
                    onCancelBatch={handleCancelBatch}
                    isAdd={false}
                    isTableHead={true}
                    ssr={handlePaginationChange}
                />
            </CardBody>
        </Card>
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags> <title>{isType} | Oralstop</title> </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Masters" breadcrumbItem={isType} />

                    <Row>
                        <Col xl='12'>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col xl="3">
                                            <label>Search by Challan or Order Number</label>
                                            <input type="number" className="form-control" onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))} placeholder="Please Search using Challan or Order Number" />
                                        </Col>
                                        <Col xl="2">
                                            <ClientDropdown callback={(e) => setFilters(prev => ({ ...prev, client: e }))} />
                                        </Col>
                                        <Col xl={2}>
                                            <label>Day wise Filter</label>
                                            <Select
                                                onChange={(e) => {
                                                    setSelectedRangeValue(e)
                                                    handleFilterChange(e.value)
                                                }}
                                                isClearable={true}
                                                value={selectedRangeValue || ''}
                                                options={sort_date_filters || []}
                                                name='clients'
                                                required={false}
                                                placeholder={'Select Filter'}
                                            />
                                        </Col>
                                        <Col xl={3}>
                                            <label>Date Range</label>
                                            <Flatpickr
                                                className="form-control d-block"
                                                placeholder="DD-MM-YYYY"
                                                options={{
                                                    mode: "range",
                                                    dateFormat: "d-m-Y"
                                                }}
                                                onChange={
                                                    (e) => {
                                                        const dates = e.map(dateString => Timezone(dateString));
                                                        setFilters(prev => ({ ...prev, _startdate: dates[0], _enddate: dates[1] }))
                                                    }
                                                }
                                            />
                                        </Col>
                                        <Col className="text-end mt-3">
                                            <button className="btn btn-primary mt-2" style={{ width: '126px' }} onClick={getData}>Filter</button>
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatables
                                        isSearch={true}
                                        columns={datatableData}
                                        showTableOnly={true}
                                        rowsLength={challans?.total_size || 0}
                                        rows={challans?.rows || []}
                                        keyField={'id'}
                                        handleAddButton={() => {
                                            window.location.href = '/orderform/create'
                                        }}
                                        title="All Orderforms"
                                        loading={orderformsLoad && (!batchProgress || batchProgress.loaded === 0)}
                                        batchProgress={batchProgress}
                                        onCancelBatch={handleCancelBatch}
                                        isAdd={true}
                                        isTableHead={true}
                                        ssr={handlePaginationChange}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Orderform
